export const IconVerifiedTransparentSVG = ({
  className,
  title,
}: {
  className?: string;
  title: string;
}) => (
  <svg
    viewBox="0 0 14 14"
    fill="currentcolor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <title>{title}</title>
    <path d="M7.003 13.4159C6.90378 13.4159 6.8104 13.3925 6.71702 13.34L1.4644 10.4234C1.27764 10.3184 1.16675 10.1259 1.16675 9.91586V4.08253C1.16675 3.87253 1.28347 3.67419 1.4644 3.57503L6.71702 0.658359C6.89211 0.559193 7.10805 0.559193 7.28314 0.658359L12.5358 3.57503C12.7225 3.68003 12.8334 3.87253 12.8334 4.08253V9.91586C12.8334 10.1259 12.7167 10.3242 12.5358 10.4234L7.28314 13.34C7.1956 13.3867 7.09638 13.4159 6.99716 13.4159H7.003ZM2.334 9.57169L7.003 12.1675L11.672 9.57169V4.42669L7.003 1.83086L2.334 4.42669V9.57169Z" />
    <path d="M6.41663 8.75089C6.26496 8.75089 6.11913 8.69255 6.00246 8.58172L4.42163 7.00089L5.24413 6.17839L6.4108 7.34505L8.74413 5.01172L9.56663 5.83422L6.81913 8.58172C6.70246 8.69839 6.55663 8.75089 6.40496 8.75089H6.41663Z" />
  </svg>
);
